/**
 * Types for Transcript Filter Configuration.
 * Re-exports from MetricRecord for convenience.
 */

import type {
  RangeFilterConfig,
  RoleFilterConfig,
} from "@/types/metrics/metadata"

/** Preset filter configurations */
export type FilterPreset = "full" | "custom"

/** Maximum number of filters allowed per include/exclude category. Mirrors the Zod cap. */
export const MAX_FILTERS_PER_CATEGORY = 3

/** Available roles with display labels */
export const TRANSCRIPT_ROLES = [
  { value: "agent" as const, label: "Agent", description: "The AI agent" },
  {
    value: "persona" as const,
    label: "Persona",
    description: "Simulated user",
  },
  { value: "tool" as const, label: "Tool", description: "Tool calls/results" },
]

/** Filter type options */
export const FILTER_TYPES = [
  {
    value: "range" as const,
    label: "Position",
    description: "First or last N messages",
  },
  {
    value: "role" as const,
    label: "Role",
    description: "Filter by speaker",
  },
] as const

/** Generate a unique ID for filters */
function generateFilterId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

/** Helper to create default range filter */
export function createDefaultRangeFilter(): RangeFilterConfig {
  return {
    type: "range",
    mode: "last_n",
    count: 5,
    id: generateFilterId(),
  }
}

/** Helper to create default role filter */
export function createDefaultRoleFilter(): RoleFilterConfig {
  return {
    type: "role",
    roles: ["agent", "persona"],
    id: generateFilterId(),
  }
}
